import { useState, useRef } from 'react'
import { PlayOutline } from 'antd-mobile-icons'
import { image } from '@/utils'
import styles from './index.module.less'

const { getVideoSnapshot } = image

function Video(props: any) {
  const { src, ...$attrs } = props
  const videoRef = useRef<HTMLVideoElement>(null)
  const [showButton, setShowButton] = useState(true) // 控制按钮显示的状态
  const [showSnapshot, setShowSnapshot] = useState(true) // 控制截图显示的状态
  const snapshotUrl = getVideoSnapshot(src, 430)

  const onVideoPlayPause = () => {
    const video = videoRef.current
    if (!video) {
      return
    }

    if (video.paused || video.ended) {
      video.play()
      setShowButton(false) // 播放时不显示按钮
    } else {
      video.pause()
      setShowButton(true) // 暂停时显示按钮
    }
  }

  // 视频播放时隐藏按钮
  const handlePlay = () => {
    setShowButton(false)
    setShowSnapshot(false)
    setTimeout(() => {
      const video = videoRef.current
      video?.play()
    }, 0)
  }

  // 视频暂停或结束时显示按钮
  const handlePause = () => setShowButton(true)
  const handleEnded = () => setShowButton(true)

  return (
    <div className={styles['video-wrap']} onClick={onVideoPlayPause}>
      {showButton && (
        <PlayOutline
          color="#dedede"
          className={styles['video-play-btn']}
          onClick={handlePlay}
        />
      )}

      {showSnapshot ? (
        <img
          src={snapshotUrl}
          className={styles['video-snapshot']}
          alt="video-snapshot"
        />
      ) : (
        <video
          {...$attrs}
          ref={videoRef}
          src={src}
          className={styles['video']}
          onPlay={handlePlay}
          onPause={handlePause}
          onEnded={handleEnded}
        />
      )}
    </div>
  )
}

export default Video
